/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowSelectRadio
 * @restrict E
 * @element div
 * @description
 * The wcRowSelectRadio directive is responsible for radio button select in datatable.
 */



angular.module('WcResponsiveTableModule').directive('wcRowSelectRadio', function() {
	return {
		restrict: 'E',
		template: '<input type="radio" name="{{responsiveTableController.id}}-radio" class="wc-radio-column" ng-click="rowSelectRadioController.selectRow()" ng-model="responsiveTableController.wcRowSelectRadio" ng-value="rowSelectRadioController.rowKey">',
		require: ['wcRowSelectRadio', '^wcResponsiveTable', '^ngModel'],
		scope: true,
		controllerAs: 'rowSelectRadioController',
		controller: ['$scope', '$element', function ($scope, $element) {
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');

			this.rowKey = $scope.$parent.rowKey;
			this.selectRow = function() {
				responsiveTableController.ngModel = [this.rowKey];
				responsiveTableController.applyModel(responsiveTableController.ngModel);
			};

			$scope.$on('table.render.complete', angular.bind(this, function() {
				if($scope.$parent.isSelected) {
					responsiveTableController.wcRowSelectRadio = this.rowKey;
				}
			}));
		}],
		link: function(scope, element, attrs, controllers) {
			var rowSelectRadioController = controllers[0];
			var responsiveTableController = controllers[1];

			 var highlightRow = function(shouldHighlight) {

				var row = element.parent().parent();
				if (shouldHighlight) {
					$(row).addClass('wc-highlight-row');
				} else {
					$(row).removeClass('wc-highlight-row');
				}

				var tableCells = row.children();
				$(tableCells).each(function(index, cell) {
					// jshint unused:true
					if(shouldHighlight) {
						$(cell).addClass('wc-highlight-row');
					} else {
						$(cell).removeClass('wc-highlight-row');
					}
				});
			};

			scope.$watch('responsiveTableController.wcRowSelectRadio', function(newRow) {
				if(responsiveTableController.ngModel) {
					var highlight = newRow === rowSelectRadioController.rowKey;

					highlightRow(highlight);
				}
			});
		}
	};
});
